<script>
import { mapState } from 'vuex'
import ChiefRoleEditMixin from '../../mixins/ChiefRoleEditMixin.vue'

export default {
    name: 'PhysicalPersonSearch',

    mixins: [ChiefRoleEditMixin],

    data() {
        return {
            isOpen: false,
            physicalPersons: [],
            clientId: '',
            search: '',
            isLoading: false,
            arrowCounter: 0,
            hasResult: false,
            showNoResult: false,
            form: {}
        }
    },

    methods: {
        resetStatus() {
            this.$store.commit('legalVM/RESET_STATUS')
        },

        showCreate() {
            this.$store.commit('legalVM/SHOW_CREATE')
        },

        onChange() {
            this.getPhysicalPersons()
        },

        async getPhysicalPersons() {
            try {
                this.showNoResult = false
                this.isOpen = true
                this.isLoading = true
                const response = await axios.get(
                    `/physicalPersons/search/${this.search}`
                )
                this.physicalPersons = response.data.data
                this.showNoResult = response.data.data.length === 0
                this.isLoading = false
                this.checkResults()
            } catch (error) {
                console.log(error)
            }
        },

        physicalPersonDetails(physicalPerson) {
            let personDetails = `${physicalPerson.firstname} ${physicalPerson.surname}`

            personDetails +=
                physicalPerson.email !== null && physicalPerson.email !== ''
                    ? ` | ${physicalPerson.email}`
                    : ''
            personDetails +=
                physicalPerson.zip_code !== null &&
                physicalPerson.zip_code !== ''
                    ? ` | ${physicalPerson.zip_code} ${physicalPerson.city}`
                    : ''

            return personDetails
        },

        async setPhysicalPerson(physicalPerson) {
            if (this.chiefRoleIsInvalid) {
                return
            }

            this.search = this.physicalPersonDetails(physicalPerson)
            const payload = this.appendRoleToPayload({
                client_id: this.client.id,
                physical_person_id: physicalPerson.id
            })

            try {
                const response = await axios.post(
                    `/${this.linkType}/physicalPersons/set`,
                    payload,
                    {
                        headers: {
                            Accept: 'application/json'
                        }
                    }
                )
                this.$bvToast.toast('Personne physique associée', {
                    title: 'Succès',
                    variant: 'success',
                    solid: true
                })
                this.$store.commit('legalVM/SET_CLIENT', response.data.data)
                this.$emit('physical-person-is-set')
                this.$store.commit('legalVM/RESET_STATUS')
            } catch (error) {
                this.$bvToast.toast(error.response.data.message, {
                    title: 'Erreur',
                    variant: 'danger',
                    solid: true
                })
                console.log(error.response)
            }
        },

        checkResults() {
            if (this.noResult) {
                this.isOpen = false
            }
        }
    },

    computed: {
        ...mapState({
            client: (state) => state.legalVM.client,
            searching: (state) => state.legalVM.searching,
            linkType: (state) => state.legalVM.linkType
        }),

        noResult() {
            return this.physicalPersons.length === 0
        },

        fewResults() {
            return this.physicalPersons.length < 3 && !this.noResult
        }
    }
}
</script>

<template>
    <div>
        <div v-if="showChiefRole" class="mb-3">
            <label>Qualité</label>
            <b-form-select
                v-model="formChiefRole"
                :options="chiefRoleSelectOptions"
                size="sm"
                :state="!chiefRoleIsInvalid"
            />
            <b-form-text v-if="roleRequired">
                Sélectionnez la qualité avant de choisir une personne dans la liste.
            </b-form-text>
        </div>

        <div class="autocomplete mb-3">
            <label>Personne physique à associer à la société</label>

            <b-form-input
                v-model="search"
                type="text"
                placeholder="Saisissez le nom de la personne physique recherchée"
                size="sm"
                @input="onChange"
            />
            <ul
                v-show="isOpen"
                id="autocomplete-results"
                class="autocomplete-results"
            >
                <li v-if="isLoading" class="loading">
                    <i class="fas fa-spinner" spin></i>
                    Recherche en cours
                </li>

                <li
                    v-for="(physicalPerson, i) in physicalPersons"
                    v-if="!isLoading"
                    :key="i"
                    class="autocomplete-result"
                    :class="{ 'is-active': i === arrowCounter }"
                    @click="setPhysicalPerson(physicalPerson)"
                >
                    {{ physicalPersonDetails(physicalPerson) }}
                </li>
            </ul>
        </div>
        <b-alert :show="showNoResult" variant="secondary">
            Aucune personne physique n'a été trouvée dans la base de données.
            Vous pouvez en créer une nouvelle
        </b-alert>
        <b-alert :show="fewResults" variant="secondary">
            Si la personne que vous cherchez n'est pas dans cette liste, vous
            pouvez en créer une nouvelle
        </b-alert>
        <b-button variant="secondary" size="sm" @click="resetStatus">
            <i class="fas fa-times fa-fw"></i> Annuler
        </b-button>
        <b-button
            v-if="fewResults || noResult"
            variant="success"
            size="sm"
            @click="showCreate"
        >
            <i class="fas fa-plus fa-fw"></i> Créer une personne physique
        </b-button>
    </div>
</template>

<style scoped>
.autocomplete {
    position: relative;
}

.autocomplete-results {
    padding: 0;
    margin: 0;
    border: 1px solid #eeeeee;
    height: 150px;
    overflow: auto;
    background-color: #fff;
}

.autocomplete-result {
    font-size: 12px;
    list-style: none;
    text-align: left;
    padding: 4px 12px;
    cursor: pointer;
}

.autocomplete-result:hover {
    background-color: #98be12;
    color: #ffffff;
}

.loading {
    list-style: none;
    text-align: center;
    padding: 0;
    cursor: none;
    margin-top: 20px;
}
</style>
